import { render, staticRenderFns } from "./systemNoticeModal.vue?vue&type=template&id=bba1aab0&scoped=true&"
import script from "./systemNoticeModal.vue?vue&type=script&lang=js&"
export * from "./systemNoticeModal.vue?vue&type=script&lang=js&"
import style0 from "./systemNoticeModal.vue?vue&type=style&index=0&id=bba1aab0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba1aab0",
  null
  
)

export default component.exports